import { Chip, styled } from "@mui/material";

const BetaChip = styled(Chip)(({ theme, size }) => ({
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.common.white,
  fontWeight: 700,
  fontSize: theme.typography.size.small,
  height: 24,
  paddingLeft: theme.spacing(0.5),
  paddingRight: theme.spacing(0.5),
  borderRadius: 24,
  ...(size === "small" && {
    height: 18,
    fontSize: 10,
    "& .MuiChip-label": {
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(0.5),
    },
  }),
}));

export default BetaChip;
